
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/sale",
      function () {
        return require("private-next-pages/shop/sale.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/sale"])
      });
    }
  